/**
 * 数据洞察相关路由
 */
import Layout from '@/views/layout/index.vue'
export default {
  path: '/dataInsight',
  component: Layout,
  redirect: '/dataInsight/categoryAnalysis',
  name: 'dataInsight',
  meta: { title: '数据洞察', icon: 'example' },
  children: [
    {
      path: 'categoryAnalysis',
      name: 'categoryAnalysis',
      component: () => import('@/views/dataInsight/categoryAnalysis'),
      meta: {
        title: '品类分析',
        icon: 'account',
        breadcrumb: ['数据洞察',  '品类分析']
      },
    },
  ],
}
